var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEllipse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 354,
    height: 115,
    viewBox: "0 0 354 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter0_f_11_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.008 4.36818C350.008 4.36814 350.008 4.37052 350.006 4.37552C350.007 4.37071 350.008 4.36822 350.008 4.36818ZM349.67 4.47431C349.771 4.50916 349.851 4.54152 349.912 4.56985C349.877 4.62769 349.829 4.69882 349.765 4.78433C349.426 5.23372 348.8 5.8316 347.812 6.57191C345.85 8.04076 342.763 9.84963 338.609 11.9568C330.321 16.1606 318.029 21.4299 302.621 27.4125C271.817 39.3724 228.696 54.1301 180.562 68.8461C132.428 83.5622 88.4261 95.4408 56.2011 102.751C40.0817 106.407 26.9447 108.912 17.7229 110.061C13.1005 110.638 9.52987 110.864 7.08231 110.743C5.84873 110.682 4.99542 110.537 4.46336 110.354C4.36213 110.319 4.28288 110.286 4.22144 110.258C4.25653 110.2 4.30414 110.129 4.36858 110.044C4.70724 109.594 5.33324 108.996 6.32187 108.256C8.28341 106.787 11.3702 104.978 15.5246 102.871C23.8126 98.6673 36.1045 93.398 51.5127 87.4155C82.316 75.4555 125.438 60.6978 173.572 45.9818C221.706 31.2657 265.707 19.3872 297.932 12.0774C314.052 8.42098 327.189 5.91595 336.411 4.76645C341.033 4.19027 344.604 3.96376 347.051 4.0846C348.285 4.14551 349.138 4.29113 349.67 4.47431ZM4.02936 110.144C4.02951 110.144 4.03144 110.146 4.03469 110.15C4.03083 110.146 4.02921 110.144 4.02936 110.144ZM4.12577 110.46C4.12562 110.46 4.12595 110.457 4.12725 110.452C4.12658 110.457 4.12593 110.46 4.12577 110.46ZM350.099 4.67826C350.103 4.68169 350.104 4.68351 350.104 4.68354C350.104 4.68357 350.102 4.68184 350.099 4.67826Z",
    stroke: "url(#paint0_linear_11_2)",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_11_2",
    x: 0.627228,
    y: 0.553223,
    width: 352.879,
    height: 113.722,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_11_2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11_2",
    x1: 326.879,
    y1: 0.740675,
    x2: 330.072,
    y2: 119.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4694ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74EBD5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse);
export default __webpack_public_path__ + "static/media/Ellipse.89b5dea3ca8b8fe76184b3f668ea65a4.svg";
export { ForwardRef as ReactComponent };